export default __webpack_public_path__ + "media/zurb/img/playground/bertrand-russell-356ec6d2fa20e22329e3c55586076cdd.jpg";